import React from 'react';
import HintWrapper from '../HintWrapper';
import './SlayTheSpireHint.scss';

const SlayTheSpireHint = ({ attemptsCount, currentCard, gameWon, isHintRevealed, onRevealHint }) => {
  return (
    <HintWrapper
      attemptsCount={attemptsCount}
      currentItem={currentCard}
      gameWon={gameWon}
      isHintRevealed={isHintRevealed}
      onRevealHint={onRevealHint}
      cssPrefix="slay-the-spire-hint"
      hintProperty="description"
      hintLabel="Description"
      showPostWinHint={true}
      unlockThreshold={5}
    >
      {/* Custom content renderer for description */}
      <div className="slay-the-spire-hint__text">
        <strong>Description:</strong> {currentCard?.description || 'No description available.'}
      </div>
    </HintWrapper>
  );
};

export default SlayTheSpireHint;